/** @file groundGrid: the 3D ground grid, one LinesMesh on the y = 0 plane of the Babylon scene. */
import { Color4 } from '@babylonjs/core/Maths/math.color.js';
import { Vector3 } from '@babylonjs/core/Maths/math.vector.js';
import { CreateLineSystem } from '@babylonjs/core/Meshes/Builders/linesBuilder.js';
import type { LinesMesh } from '@babylonjs/core/Meshes/linesMesh.js';
import type { Scene } from '@babylonjs/core/scene.js';
import { VIEWPORT_COLORS } from './viewportColors';

/** Grid extent: `HALF` units each way from the origin, a line every unit, every `MAJOR`th line brighter. */
const HALF = 20;
const MAJOR = 4;

/**
 * `2 x (2 HALF + 1)` lines (41 along Babylon x, 41 along z) at y = 0, i.e. pose's z = 0 ground with 1-unit tiles, so
 * orbiting turns the grid with the puppet. Not pickable; rendering group 0, drawn under the puppet.
 */
export function groundGrid(scene: Scene): LinesMesh {
  const minor = Color4.FromHexString(`${VIEWPORT_COLORS.gridMinor}ff`);
  const major = Color4.FromHexString(`${VIEWPORT_COLORS.gridMajor}ff`);
  const lines: Vector3[][] = [];
  const colors: Color4[][] = [];
  for (let i = -HALF; i <= HALF; i++) {
    const c = i % MAJOR === 0 ? major : minor;
    lines.push([new Vector3(i, 0, -HALF), new Vector3(i, 0, HALF)], [new Vector3(-HALF, 0, i), new Vector3(HALF, 0, i)]);
    colors.push([c, c], [c, c]);
  }
  const mesh = CreateLineSystem('viewport-grid', { lines, colors }, scene);
  mesh.isPickable = false;
  return mesh;
}
